import { http } from '@/api/client/httpClient';

export interface MatchingEngineUploadLogRowDto {
  uploadDate: string;
  providerName: string;
  user: string;
  description: string;
}

export interface MatchingEngineActionLogRowDto {
  date: string;
  user: string;
  action: string;
  providerName: string;
  ticket: string;
  statementId: string;
  comment: string;
}

const BASE = '/api/app/matching-engine-logs';

export const matchingEngineLogsApi = {
  getUploadLogs: () => http.get<MatchingEngineUploadLogRowDto[]>(`${BASE}/upload-logs`).then((r) => r.data),
  getActionLogs: () => http.get<MatchingEngineActionLogRowDto[]>(`${BASE}/action-logs`).then((r) => r.data),
};
